export default "__VITE_ASSET__6cc7e199__"